import React, { useEffect, useState } from 'react'
import './INCSUBroleanagement.css'
import INCSUBSearchbar from '../../components/common/SearchBar/INCSUBSearchbar';
import INCSUBButton from '../../components/common/Button/INCSUBButton';
import { useDispatch, useSelector } from 'react-redux';
import { getAllEmployees, getUserList, updateUserRole } from '../../services/userServices';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { setUserList } from '../../features/users/userSlice';
import INCSUBCreaterole from '../../components/Role Management/CreateRole';


function INCSUBroleanagement() {

    const dispatch = useDispatch();
    const [shimmer, setShimmer] = useState(false);
    const navigate = useNavigate();
    const userList = useSelector((state) => state.user.userList);
    const [isAsk, setIsAsk] = useState(false);
    const [isOpenPopUp, setIsOpenPopup] = useState(false);
    const [empDeleteLoader, setEmpDeleteLoader] = useState();
    const [selectedEmp, setSelectedEmp] = useState(null);
    const [isAddEmp, setIsAddEmp] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null)
    const [isBtnLoader, setIsBtnLoader] = useState(false);
    const [isOpenUpdatePopup, setIsOpenUpdatePopUp] = useState();
   

    /**
     * @@govinddindewad
     * fetchUserData - Fetches a paginated list of users from the server.
     *
     * This function makes an API call to fetch employee data based on the provided 
     * filters, such as search key, page number, and size. It updates the Redux 
     * store with the fetched data and manages UI states like loading indicators.
     *
     * @async
     * @function
     * @param {Object} [params={}] - Optional parameters for fetching data.
     * @param {string} [params.key=""] - Search key for filtering users.
     * @param {number} [params.page=0] - Page number for pagination.
     * @param {number} [params.size=10] - Number of items to fetch per page.
     * 
     * @throws Displays error messages if the API call fails.
     *
     * Side Effects:
     * - Updates Redux state with the fetched user list.
     * - Handles unauthorized access by clearing local storage and redirecting.
     * - Manages UI states like loading indicators (`setShimmer`).
     */


    // Asynchronous function to fetch user data from the server.
    const fetchUserData = async ({
        keyState = "", // Optional search key for filtering user data.
        page = 0, // Current page number for pagination.
        size = 10 // Number of items per page.
    } = {}) => {
        setShimmer(true); // Set shimmer (loading indicator) to true while data is being fetched.

        try {
            // Call the API to get all employees with the provided parameters.
            const userList = await getAllEmployees(keyState, page, size);
            if (userList.status === 200) {
                // If API call is successful, update the Redux store with the fetched data.
                dispatch(setUserList(userList.data.data));

            } else if (userList.status === 401) {
                // If the user is unauthorized, clear local storage and redirect to login page.
                window.localStorage.setItem('userData', null);
                window.localStorage.setItem('token', null);
                navigate('/login');
            } else if (userList.status === 301) {
                toast.error(userList.message);
            }else if (userList.status === 500) {
                toast.error("Internal Server Error");
            }else if (![200, 401,301].includes(userList.status)) {
                // If API returns an unexpected status, display an error toast with the server's message.
                toast.error(userList.data.message);
            }
        } catch (error) {
            // Handle any unexpected errors during the API call.
            toast.error("Something went wrong");
        } finally {
            // Reset the shimmer (loading indicator) state regardless of success or failure.
            setShimmer(false);
        }
    };

    // useEffect hook to fetch user data when the component is mounted.
    useEffect(() => {
        fetchUserData(); // Trigger the fetchUserData function on component load.
    }, []);

 const searchRoleFunc = (key) => {
        fetchUserData({keyState:key})
    }

    /**
     * convertDateFormat - Converts a date string into a readable format.
     *
     * This utility function takes a raw date string and formats it using the 
     * `toLocaleDateString` method to create a more user-friendly date representation.
     *
     * @function
     * @param {string} date - The raw date string to be formatted.
     * @returns {string} - A human-readable formatted date string (e.g., "May 6, 2025").
     *
     * Example:
     * ```javascript
     * const formattedDate = convertDateFormat("2025-05-06T12:00:00Z");
     * ```
     */

    // Function to convert a date string into a readable format.
    const convertDateFormat = (date) => {
        const dateObj = new Date(date); // Parse the input date string into a Date object.
        const options = { year: 'numeric', month: 'long', day: 'numeric' }; // Format options for the date.
        const formattedDate = dateObj.toLocaleDateString('en-US', options); // Convert the date to a localized string.
        return formattedDate; // Return the formatted date string.
    };

    // Function to toggle the "Add Employee" modal or form.
    const handleIsAddEmp = () => {
        setSelectedEmp(null); // Reset the selected employee state to null.
        setIsAddEmp(!isAddEmp); // Toggle the state of the "Add Employee" form or modal.
    };



    /**
     * @@govind dindewad
 * handleUpdateEmp - Function to handle the deletion of an employee from the admin list.
 *
 * This function performs the following tasks:
 * 1. Validates if an employee is selected before proceeding.
 * 2. Updates the user's role to 'user' via an API call.
 * 3. On successful API response:
 *    - Removes the selected employee from the admin list.
 *    - Updates the Redux store with the modified admin list.
 * 4. Handles specific API error responses:
 *    - Status 401: Logs the user out and redirects to the login page.
 *    - Other unexpected statuses: Displays an error toast with the server message.
 * 5. Manages UI state by toggling loading indicators, resetting selections, and closing dialogs.
 * 6. Provides error handling for unexpected issues.
 *
 * Dependencies:
 * - `updateUserRole`: API function to update user roles.
 * - `dispatch`: Redux dispatch function to update the state.
 * - `toast`: Utility to display notifications.
 * - `navigate`: Navigation function to redirect users.
 *
 * Side Effects:
 * - Updates `userList` in the Redux store.
 * - Modifies local storage in case of unauthorized access.
 * - Updates UI states such as loaders, modals, and selection states.
 *
 * @async
 * @throws Displays error messages if the API call or other operations fail.
 */

    const handleUpdateEmp = async (role) => {
        // Check if an employee is selected before proceeding with deletion.
        if (!selectedEmp) {
            toast.warning("Select User before proceed"); // Display a warning toast message if no user is selected.
            return; // Exit the function early if no employee is selected.
        }
        setEmpDeleteLoader(true);
        const selfuserId = JSON.parse(window.localStorage.getItem("userData")).userId
        if (selectedEmp.userId === selfuserId) {
            toast.warning("You can't change self role access");
            setIsOpenUpdatePopUp(false)
            setIsAsk(false); // Close any confirmation prompts.
            setIsOpenPopup(false); // Close the popup dialog, if open.
            return 0
        }

        setIsBtnLoader(true); // Set a loading state to indicate a process is ongoing.

        let userObject;
        if (role === 'ROLE_USER') {
            // Create a new user object with updated role set to 'user'.
            userObject = { ...selectedEmp, userRole: 'ROLE_USER' };

        } else {
            userObject = { ...selectedEmp };
        }

        try {
            // Attempt to update the user's role through the API.
            const userData = await updateUserRole(userObject);

            // Check the response status from the API call.
            if (userData.status === 200) {
                if (selectedEmp.userRole !== 'ROLE_USER') {
                    // If successful, filter out the deleted user from the admin list.
                    const updatedList = userList && userList.adminList.filter((user) => user.userId !== selectedEmp.userId);
                    // Dispatch an action to update the Redux store with the updated admin list.
                    dispatch(setUserList({
                        ...userList,
                        adminList: updatedList
                    }));
                    toast.success("Role updated successfully")
                } else {
                    const updatedList = userList.adminList.map(user =>
                        user.userId === selectedEmp.userId
                            ? { ...user, ...selectedEmp }
                            : user
                    );
                    dispatch(setUserList({
                        ...userList,
                        adminList: updatedList
                    }));
                }

                setIsOpenUpdatePopUp(false)
                setSelectedEmp(null); // Reset the selected employee state to null.

            } else if (userData.status === 401) {
                // If the user is unauthorized, clear local storage and navigate to the login page.
                window.localStorage.setItem('userData', null);
                window.localStorage.setItem('token', null);
                navigate('/login');
            } else if (![200, 401].includes(userData.status)) {
                // If the status is any unexpected value, display an error toast message.
                toast.error(userData.data.message);
            }

            setIsAsk(false); // Close any confirmation prompts.
            setIsOpenPopup(false); // Close the popup dialog, if open.

        } catch (error) {
            // Handle any exceptions during the API call or process.
            toast.error("Something went wrong");
            setIsOpenPopup(false); // Close the popup dialog, if open.
        } finally {
            // Reset the loading state regardless of success or failure.

            setIsBtnLoader(false);
            setEmpDeleteLoader(false)
        }
    };
    return (
        <div className='INCSUBRolemanagement_main_ctn'>
            <div className='INCSUBRolemanagement_searchbtn_section'>
                <INCSUBSearchbar width={500} height={38} background={''} placeholder={'Search'} param={{func:searchRoleFunc}} />
                <INCSUBButton text={'Add'} clickFun={handleIsAddEmp} />
            </div>
            <div className='INCSUBComplaint_userlist_section'>
                {userList && userList.adminList?.length > 0 ? <div className='INCSUBUser_userlist_section_table_conatiner'>
                    {shimmer ?
                        <div>
                            <div className="animate-pulse">
                                <div className="border border-gray-200 rounded-lg overflow-hidden">
                                    <div className="flex bg-gray-100 py-2 px-4">
                                        <div className="w-1/12 h-6 bg-gray-300 rounded mr-2"></div>
                                        <div className="w-2/12 h-6 bg-gray-300 rounded mr-2"></div>
                                        <div className="w-3/12 h-6 bg-gray-300 rounded mr-2"></div>
                                        <div className="w-2/12 h-6 bg-gray-300 rounded mr-2"></div>
                                        <div className="w-2/12 h-6 bg-gray-300 rounded mr-2"></div>
                                        <div className="w-2/12 h-6 bg-gray-300 rounded"></div>
                                    </div>
                                    {Array(20).fill(0).map((_, index) => (
                                        <div key={index} className="flex py-2 px-4">
                                            <div className="w-1/12 h-6 bg-gray-300 rounded mr-2"></div>
                                            <div className="w-2/12 h-6 bg-gray-300 rounded mr-2"></div>
                                            <div className="w-3/12 h-6 bg-gray-300 rounded mr-2"></div>
                                            <div className="w-2/12 h-6 bg-gray-300 rounded mr-2"></div>
                                            <div className="w-2/12 h-6 bg-gray-300 rounded mr-2"></div>
                                            <div className="w-2/12 h-6 bg-gray-300 rounded"></div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div> :
                        <table className='INCSUBuser_table'>
                            <thead className='INCSUBuser_table_head'>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Mail Id</th>
                                    <th>Join Date</th>
                                    <th>Role</th>
                                    <th>Action</th>

                                </tr>
                            </thead>
                            <tbody className='INCSUBuser_table_body'>
                                {
                                    userList && userList.adminList.length > 0 && userList.adminList.map((user, index) =>
                                        <tr
                                        >
                                            <td>{index + 1}</td>
                                            <td><div className='INCSUBprofile_name_container'>
                                                <div className='INCSUBProfile_image_holder'>
                                                    <img src={user.userImage ? user.userImage : '/public/assets/icons/common/defaultImage.png'} alt='/' />
                                                </div>
                                                <div className='name_conatiner'>
                                                    <div className='name'>{user?.userFullName}</div>
                                                    <div className='mobile_no'>{user?.userMobileNumber}</div>
                                                </div>
                                            </div></td>
                                            <td>{user?.userEmail}</td>
                                            <td>{user?.createdAt ? convertDateFormat(user?.createdAt) : ''}</td>
                                            <td>{user?.userRole.replace("ROLE_", "").toLowerCase().replace(/^\w/, c => c.toUpperCase())}</td>
                                            <td className='INCSUB_UserAction'>
                                                <div className='INCSUB_UserActionDeleteIcon'>
                                                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => {
                                                        setSelectedEmp(user)
                                                        setIsOpenPopup(true)
                                                        setIsAsk(true);
                                                    }}>
                                                        <path d="M11.25 13.5H12.75H24.75" stroke="black" stroke-opacity="0.8" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M23.248 13.5V24C23.248 24.3978 23.09 24.7794 22.8087 25.0607C22.5274 25.342 22.1459 25.5 21.748 25.5H14.248C13.8502 25.5 13.4687 25.342 13.1874 25.0607C12.9061 24.7794 12.748 24.3978 12.748 24V13.5M14.998 13.5V12C14.998 11.6022 15.1561 11.2206 15.4374 10.9393C15.7187 10.658 16.1002 10.5 16.498 10.5H19.498C19.8959 10.5 20.2774 10.658 20.5587 10.9393C20.84 11.2206 20.998 11.6022 20.998 12V13.5" stroke="black" stroke-opacity="0.8" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M16.502 17.25V21.75" stroke="black" stroke-opacity="0.8" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M19.498 17.25V21.75" stroke="black" stroke-opacity="0.8" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </div>
                                                <div className='INCSUB_UserActionEditeIcon'>
                                                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => {
                                                        setSelectedEmp(user)
                                                        setIsOpenUpdatePopUp(true)
                                                    }}>
                                                        <path d="M18 24H24.75" stroke="black" stroke-opacity="0.8" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M21.375 11.6222C21.6734 11.3239 22.078 11.1562 22.5 11.1562C22.7089 11.1562 22.9158 11.1974 23.1088 11.2774C23.3019 11.3573 23.4773 11.4745 23.625 11.6222C23.7727 11.77 23.8899 11.9454 23.9699 12.1384C24.0498 12.3314 24.091 12.5383 24.091 12.7472C24.091 12.9562 24.0498 13.1631 23.9699 13.3561C23.8899 13.5491 23.7727 13.7245 23.625 13.8722L14.25 23.2472L11.25 23.9972L12 20.9972L21.375 11.6222Z" stroke="black" stroke-opacity="0.8" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </div>
                                                <div></div>
                                            </td>


                                        </tr>)
                                }

                            </tbody>
                        </table>
                    }

                </div> : <div className='no_data_found'>No Data Found</div>}
                {isOpenPopUp ?
                    <div className='INCSUBCategory_permission_popup'>{
                        isAsk ?
                            <div className='INCSUBCategory_ask_container' >
                                <div className='INCSUBCategory_ask' style={{ display: empDeleteLoader ? 'none' : null }}>
                                    <svg width="100" height="94" viewBox="0 0 100 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="49.0815" cy="46.0102" r="32.0883" fill="#FF6565" />
                                        <circle cx="13.778" cy="7.87368" r="7.87368" fill="#FF6565" fill-opacity="0.2" />
                                        <circle cx="93.1719" cy="15.749" r="5.90526" fill="#FF6565" fill-opacity="0.2" />
                                        <ellipse cx="3.93684" cy="69.8744" rx="3.93684" ry="3.60877" fill="#FF6565" fill-opacity="0.2" />
                                        <circle cx="34.777" cy="91.2028" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                        <circle cx="85.2985" cy="83.3356" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                        <circle cx="89.235" cy="58.3903" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                        <circle cx="56.4274" cy="3.93717" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                        <path d="M47.5491 51.7008L46 32H52.1168L50.5677 51.7008H47.5491ZM46.278 60.0022V54.4812H51.8388V60.0022H46.278Z" fill="white" />
                                    </svg>




                                    <div className='INCSUBCategory_permission_header'>
                                        Are you sure to delete this employee?
                                    </div>
                                    <div className='INCSUBCategory_permission_btn_container'>
                                        <div className="INCSUBCategory_image_upload_btn">
                                            <INCSUBButton text={'Delete'} clickFun={() => handleUpdateEmp("ROLE_USER")} isLoader={isBtnLoader} />
                                            <div className='upload_cancel_btn' onClick={() => setIsOpenPopup(false)}>Cancel</div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    empDeleteLoader ? <div className='categoryloader' /> : null
                                }
                            </div> : <div className='INCSUBCategory_ask_container'>
                                <svg width="100" height="94" viewBox="0 0 100 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="49.0805" cy="46.0102" r="32.0883" fill="#FF6565" />
                                    <path d="M59 37L41 55" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M41 37L59 55" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                                    <circle cx="13.778" cy="7.87368" r="7.87368" fill="#FF6565" fill-opacity="0.2" />
                                    <circle cx="93.1709" cy="15.749" r="5.90526" fill="#FF6565" fill-opacity="0.2" />
                                    <ellipse cx="3.93684" cy="69.8744" rx="3.93684" ry="3.60877" fill="#FF6565" fill-opacity="0.2" />
                                    <circle cx="34.777" cy="91.2028" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                    <circle cx="85.2985" cy="83.3356" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                    <circle cx="89.234" cy="58.3903" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                    <circle cx="56.4274" cy="3.93717" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                </svg>
                                <div className='INCSUBCategory_permission_header'>
                                    Can’t delete
                                </div>
                                <div className='INCSUBCategory_permission_text'>Opps There is Error.</div>
                                <div className='INCSUBCategory_permission_btn_container'>
                                    <div className="INCSUBCategory_image_upload_btn">
                                        <div className='INCSUBCategory_upload_btn' onClick={() => setIsOpenPopup(false)}>Ok, Got it</div>
                                    </div>
                                </div>
                            </div>
                    }


                    </div> : null
                }{
                    isOpenUpdatePopup ? <div className='INCSUBCategory_permission_popup'>
                        <div className='INCSUBCategory_ask_container' >
                            <h1 className='INCSUBPopup_heading'>Update Role</h1>
                            <div className='INCSUBCategory_ask_update' style={{ display: empDeleteLoader ? 'none' : null }}>
                                <div className="INCSUBUserinfo_card">
                                    <div className="INCSUBUserinfo_card_nameimgno">
                                        <div className="INCSUBUserinfo_card_img">
                                            <img className='INCSUB_UserImgTag' src={selectedEmp?.userImage ? selectedEmp.userImage : '/assets/icons/common/defaultImage.png'} alt={`${'default'} img`} />
                                        </div>
                                        <div className="INCSUBUserinfo_card_nameno">
                                            <p className="INCSUBUserinfo_card_name_para">{selectedEmp?.userFullName}</p>
                                            <p className="INCSUBUserinfo_card_no_para">{selectedEmp?.userMobileNumber}</p>
                                        </div>
                                    </div>
                                    <div className="INCSUBUserinfo_card_selectrole_ctn">
                                        <div className="INCSUBUserinfo_card_selectrole" >
                                            <select className="INCSUBUser_roleselect" value={selectedEmp.userRole} onChange={(e) => setSelectedEmp({ ...selectedEmp, userRole: e.target.value })}>
                                                <option value={'ROLE_SUPERADMIN'}>Super Admin</option>
                                                {/* <option value={'ROLE_ADMIN'}>Admin</option>
                                                <option value={'ROLE_CONTENTMANAGER'}>Content Manager</option>
                                                <option value={'ROLE_SUPPORTMANAGER'}>Support Manager</option> */}
                                                <option value={'ROLE_USER'}>User</option>


                                            </select>
                                        </div>

                                    </div>
                                </div>
                                <div className='INCSUBCategory_permission_btn_container'>
                                    <div className="INCSUBCategory_image_upload_btn">
                                        <INCSUBButton text={'Update'} clickFun={() => handleUpdateEmp(selectedEmp?.userRole)} isLoader={isBtnLoader} />
                                        <div className='upload_cancel_btn' onClick={() => {
                                            setIsOpenUpdatePopUp(false)
                                            setSelectedEmp(null)
                                        }}>Cancel</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null
                }
            </div>
            {isAddEmp ? <INCSUBCreaterole handleIsAddEmp={handleIsAddEmp} /> : null}
        </div>
    )
}

export default INCSUBroleanagement
